export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7262.977331f2.jpg";